import React, {useEffect, useState} from 'react';
import {IDictionaryItem} from "../../../types/IDictionaryItem";
import {hhApi} from "../../../api/hh-api";
import {Button} from "react-bootstrap";
import axiosInstance from "../../../api";
import {toast} from "react-toastify";
import moment from "moment";
import SearchSelect from "../../../components/search-select";
import {useStores} from "../../../stores";

type FreeVacancy =  {
  isFree: boolean | null,
  vacancyName: string | null
}
const VacancyLoadForm = () => {
  const [dictionaries, setDictionaries] = useState<{ [key: string]: IDictionaryItem[] }>({
    hhVacancy: [],
    ukiVacancy: [],
    hhArchivedVacancy: [],
  })

  const [isFreeVacancy, setIsFreeVacancy] = useState<FreeVacancy>({
    isFree: null,
    vacancyName: null
  })

  const [formValues, setFormValues] = useState<any>({
    hhVacancyId: "",
    ukiVacancyId: "",
    hhVacancyCheckbox: false,
  });

  const [isArchived, setIsArchived] = useState<boolean>(false);
  const fetchVacancyHH = async () => {
    const employerId = sessionStorage.getItem('employerId')
    const data = await hhApi.getVacancyHH(employerId)
    setDictionaries((prev) => ({ ...prev, hhVacancy: data }));
  }

  const fetchArchivedVacancyHH = async () => {
    const employerId = sessionStorage.getItem('employerId')
    const data = await hhApi.getArchivedVacancyHH(employerId)
    setDictionaries((prev) => ({ ...prev, hhArchivedVacancy: data }));
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = e.target.checked;
    setIsArchived(isChecked);

    if (!isChecked) {
      setFormValues((prevValues: any) => ({
        ...prevValues,
        hhVacancyId: "",
        ukiVacancyId: "",
      }));
    }
  };
  const {authStore} = useStores()
  const vacancyCompanyId = authStore.user?.vacancyCompany || formValues.vacancyCompanyId || null

  const fetchVacancyUKI = async () => {
    const {data} = await axiosInstance.post<any>(`api/vacancy/findShortFree`, { vacancyCompanyId })

    setDictionaries((prev) => ({ ...prev, ukiVacancy: data }));
  }
  useEffect(() => {
    fetchVacancyHH()
    fetchVacancyUKI()
    fetchArchivedVacancyHH()
  }, []);

  const handleForm = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!formValues.hhVacancyId && !formValues.ukiVacancyId) {
      toast.warning('Необходимо заполнить хотя бы одно поле!', { autoClose: 3000 });
      return event.preventDefault()
    }
    try {
      const elem: any = sortedCurrentDic?.find((a) => a.id === formValues.hhVacancyId);

      let formattedString
      if (elem) {
        formattedString = `
          ${elem.name}
          ${elem.archived_at ? moment(elem.archived_at).format('DD.MM.YYYY') : ''}
        `.replace(/\s+/g, ' ').trim();
      }
      const res = await axiosInstance.post<any>(`api/vacancy/chainVacancyHH`, {
        id: formValues.ukiVacancyId,
        legacy_hh: formValues.hhVacancyId,
        legacy_hh_name: formattedString || elem.name
      })
      toast.success('Вакансия успешно связана!', { autoClose: 3000 });
      fetchVacancyUKI()
      setFormValues({
        hhVacancyId: '',
        ukiVacancyId: '',
      })
    } catch (e) {
      toast.error('Ошибка при связывании вакансии. Повторите попытку.', { autoClose: 3000 });
      console.log(e)
    }
  }

  const handleChangeSelect = async (event: React.ChangeEvent<any>) => {
    const { name, value } = event.target;

    setFormValues((prev: any) => ({
      ...prev,
      [name]: +value,
    }));
    if (name === 'hhVacancyId') {
      const {data} = await axiosInstance.get<FreeVacancy>(`api/vacancy/free/${+event.target.value}`)
      setIsFreeVacancy(data)
    }
  }

  const handleValueChange = (value: string) => {
    setFormValues({ ...formValues, hhVacancyId: value });
  };

  const currentDic = isArchived ? dictionaries?.hhArchivedVacancy : dictionaries?.hhVacancy || []
  const sortedCurrentDic = currentDic?.sort((a, b) => b.name.localeCompare(a.name));

  return (
    <div>
      <form onSubmit={(e) => handleForm(e)} className="white-form-block mt-4 pt-4">
        <div className="form-group mb-4 flex items-center justify-between">
          {/* Блок с select */}
          <div className="flex-grow">
            <label htmlFor="vacancySelect" className="block font-medium text-gray-700 mb-2">
              <span className="text-red-500">*</span> Вакансия из HH
            </label>
            <SearchSelect
              sortedCurrentDic={sortedCurrentDic}
              selectedValue={formValues.hhVacancyId}
              onValueChange={handleValueChange}
            />
          </div>
        </div>
        <div className="flex mb-4">
          <label
            htmlFor="hhVacancyCheckbox"
            className="ml-2 !w-fit text-gray-700 text-sm font-medium cursor-pointer"
          >
            Показать только вакансии из архива:
          </label>
          <input
            type="checkbox"
            id="hhVacancyCheckbox"
            checked={isArchived}
            onChange={handleCheckboxChange}
            className="form-checkbox h-5 w-5 text-blue-600 rounded focus:ring-blue-500"
          />
        </div>
        {(!isFreeVacancy.isFree && isFreeVacancy.isFree !== null) && (
          <div className="alert alert-danger" role="alert">
            Данная вакансия привязана к {isFreeVacancy.vacancyName}
          </div>
        )}

        {formValues.hhVacancyId &&
            <>
                <div className="form-group mb-5 d-flex">
                    <label>
                        <span className="text-danger h5">*</span> Вакансия из UKI
                    </label>
                    <select
                        className="form-select"
                        id="vacancySelect"
                        name={'ukiVacancyId'}
                        value={formValues.ukiVacancyId}
                        required={true}
                        onChange={handleChangeSelect}
                        aria-label="HH vacancy select"
                    >
                        <option value="">-Выберите-</option>
                      {dictionaries?.ukiVacancy?.map((vacancy) => (
                        <option key={vacancy.id} value={vacancy.id}>
                          {vacancy.position}
                        </option>
                      ))}
                    </select>
                </div>

            </>


        }

        <Button disabled={!formValues.ukiVacancyId} type="submit" size={'lg'}>Привязать вакансию</Button>
      </form>
    </div>
  );
};

export default VacancyLoadForm;